module.exports = __webpack_public_path__ + "media/images/lb/246-5e9f018677a8d289f9f90d2aefe2681d.svg";